export default "__VITE_ASSET__TTzvEiid__"